import * as React from "react";
const SvgKebab = props => <svg xmlns="http://www.w3.org/2000/svg" width={3} height={13} viewBox="0 0 3 13" {...props}><circle cx={1.5} cy={1.5} r={1.5} /><circle cx={1.5} cy={6.5} r={1.5} /><circle cx={1.5} cy={11.5} r={1.5} /></svg>;
export default SvgKebab;